import { useState } from 'react';

import { initialValues } from '@features/details/Details/initialValues';
import { YourDetailsFormValues } from '@src/types/yourDetails';

import { type BasketProviderProps, type DetailsContextState } from '../types';
import { DetailsContext } from './Context';

const DetailsProvider = ({ children }: BasketProviderProps) => {
  const [details, setDetails] = useState(initialValues);

  const setDetailsItem = <K extends keyof YourDetailsFormValues>(
    key: K,
    value: YourDetailsFormValues[K]
  ) => {
    setDetails({
      ...details,
      [key]: value,
    });
  };

  const resetDetails = () => setDetails(initialValues);

  const stateValues: DetailsContextState = {
    details,
    setDetailsItem,
    resetDetails,
  };

  return <DetailsContext value={stateValues}>{children}</DetailsContext>;
};

export { DetailsProvider };
